const oneMonthBelowMax = () => {
  let Currentdate = new Date();
  let todayDate = Currentdate.getDate();
  let todayMonth = Currentdate.getMonth();
  let todayYear = Currentdate.getFullYear();
  if (todayDate <= 26) {
    Currentdate.setMonth(todayMonth);
  } else {
    Currentdate.setMonth(todayMonth + 1);
  }
  let oneMonthBelowSet = Currentdate.getMonth();
  oneMonthBelowSet = ZeroPrefix(oneMonthBelowSet);

  return `${todayYear}-${oneMonthBelowSet}-26`;

  // if(Currentdate.getDate())
};

 export const toDateMax = () => {
  let Currentdate = new Date();
  let todayDate = Currentdate.getDate();
  let todayMonth = Currentdate.getMonth();
  let todayYear = Currentdate.getFullYear();
  todayDate = ZeroPrefix(todayDate);
  todayMonth = ZeroPrefix(todayMonth + 1);
  return `${todayYear}-${todayMonth}-${todayDate}`;
};

export const ZeroPrefix = (number) => {
  let PrefixedNumber;
  if (number < 10) {
    PrefixedNumber = `0${number}`;
  } else {
    PrefixedNumber = number;
  }
  return PrefixedNumber;
};

const getPreviousDay = (date = new Date()) => {
  const previous = new Date(date.getTime());
  previous.setDate(date.getDate());

  let previousDate = previous.getDate();
  let previousMonth = previous.getMonth();
  let previousYear = previous.getFullYear();
  previousDate = ZeroPrefix(previousDate);
  previousMonth = ZeroPrefix(previousMonth + 1);
  return `${previousYear}-${previousMonth}-${previousDate}`;
};
export const CommonDate = {
  onemonthBelow: oneMonthBelowMax(),
  toDateMax: toDateMax(),
  getPreviousDay: getPreviousDay(),
};

